import { Step, StepLabel, Stepper } from '@mui/material'

interface VehicleCheckInStepperProps {
  activeStep: number
}

export default function VehicleCheckInStepper({ activeStep }: VehicleCheckInStepperProps) {
  return (
    <Stepper alternativeLabel activeStep={activeStep}>
      <Step completed={activeStep > 0}>
        <StepLabel>Scan or Search</StepLabel>
      </Step>

      <Step completed={activeStep > 1}>
        <StepLabel>Report Damage</StepLabel>
      </Step>

      <Step completed={activeStep > 2}>
        <StepLabel>Damage Photos</StepLabel>
      </Step>
    </Stepper>
  )
}
